import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout';
import { Landing } from './routes/Landing';

// Everything heavy loads only when needed, so the landing page stays light.
const Workspace = lazy(() => import('./routes/Workspace'));
const Library = lazy(() => import('./routes/Library'));
const Settings = lazy(() => import('./routes/Settings'));
const About = lazy(() => import('./routes/About'));
const Help = lazy(() => import('./routes/Help'));
const Privacy = lazy(() => import('./routes/Privacy'));

function Loading() {
  return <div className="p-10 text-center text-ink-3">Loading...</div>;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Landing />} />
          <Route path="app" element={<Suspense fallback={<Loading />}><Workspace /></Suspense>} />
          <Route path="library" element={<Suspense fallback={<Loading />}><Library /></Suspense>} />
          <Route path="settings" element={<Suspense fallback={<Loading />}><Settings /></Suspense>} />
          <Route path="about" element={<Suspense fallback={<Loading />}><About /></Suspense>} />
          <Route path="help" element={<Suspense fallback={<Loading />}><Help /></Suspense>} />
          <Route path="privacy" element={<Suspense fallback={<Loading />}><Privacy /></Suspense>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function NotFound() {
  return (
    <div className="mx-auto max-w-xl p-10 text-center">
      <h1 className="font-serif text-3xl">Page not found</h1>
      <p className="mt-3 text-ink-2">That page doesn't exist. Your photos are safe in this browser.</p>
    </div>
  );
}
